import { animate, state, style, transition, trigger } from '@angular/animations';

export const collapseAnimations = [
  trigger('verticalCollapse', [
    state(
      'collapsed',
      style({
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        marginTop: 0,
        marginBottom: 0,
        opacity: 0,
        overflow: 'hidden',
      })
    ),
    state(
      'expanded',
      style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*',
        marginTop: '*',
        marginBottom: '*',
        opacity: 1,
      })
    ),
    transition('collapsed <=> expanded', [animate('300ms ease-in-out')])]),

  ];
